import * as React from 'react';
import { BarChart, ColumnChart, LineChart, PieChart } from 'react-chartkick';
import * as Configuration from '../../configuration';

//var Chart = require('chart.js');
//var ChartDataLabels = require('../../../node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js');

//Chart.plugins.unregister(ChartDataLabels);

export type ChartDatum = (string | number)[]

type ScanChartProps = {
    chartType: string,
    collate: boolean,
    colors: string[],
    curve?: boolean,
    data: any, //ChartDatum[], this type doesn't support data with multiple datapoints per named column
    defaultClosed: boolean,
    discrete: boolean,
    displayIcon: boolean,
    groupBy: string[],
    height: string,
    legend: string,
    title: string,
    responsive?: boolean,
    stacked?: boolean,
    style?: any,
    width: string
}

type ScanChartActions = {}

type ScanChartAllProps = ScanChartProps & ScanChartActions;

export default class ScanChart extends React.PureComponent<ScanChartAllProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    groupByArray(xs, key) {
        return xs.reduce((rv, x) => {
            let val = key instanceof Function ? key(x) : x[key];
            let element = rv.find((r) => r && r.key === val);
            if (element) {
                element.values.push(x);
            } else {
                rv.push({ key: val, values: [x] });
            }
            return rv;
        }, []);
    }

    render() {
        const { data, groupBy, curve, chartType, width, height, colors, legend, stacked, displayIcon, discrete, collate, defaultClosed, responsive } = this.props;
        var summaryData: ChartDatum[] = undefined;

        if (data) {
            var defaultColors = colors ? colors : ['#63AE6E', '#F15E22', '#FFC00F', '#D1E6B4', '#817D68'];

            var results = data;
            
            summaryData = results

            let chart = <BarChart data={summaryData} width={width} height={height} legend={legend} colors={defaultColors} discrete={discrete} />;
            switch (chartType) {
                case 'LineChart':
                    chart = <LineChart curve={curve} data={summaryData} width={width} height={height} legend={legend} colors={defaultColors} discrete={discrete} />;
                    break;
                case 'PieChart':
                    chart = <PieChart data={summaryData}
                        width={width} height={height}
                        legend={legend} colors={defaultColors}
                        discrete={discrete} donut={Configuration.custom.donutCharts} />;
                    break;
                case 'ColumnChart':
                    chart = <ColumnChart stacked={stacked} data={summaryData} width={width} height={height} legend={legend} colors={defaultColors} discrete={discrete} />;
                    break;
                case 'BarChart':
                    chart = <BarChart responsive={responsive} stacked={stacked} data={summaryData} width={width} height={height} legend={legend} colors={defaultColors} discrete={discrete} />;
                    break;
            }

            return chart;
        }
        else {
            return null;
        }
    }
}
